import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSignalCellular0Bar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.82494 20H19.9749V6.84996L6.82494 20ZM4.42494 22C3.97494 22 3.66227 21.7956 3.48694 21.387C3.31227 20.979 3.38327 20.6166 3.69994 20.3L20.2749 3.72496C20.5916 3.4083 20.9543 3.3373 21.3629 3.51196C21.7709 3.6873 21.9749 3.99996 21.9749 4.44996V21C21.9749 21.2833 21.8793 21.5206 21.6879 21.712C21.4959 21.904 21.2583 22 20.9749 22H4.42494Z",
		fill: "currentColor"
	})
});
export default SvgSignalCellular0Bar;
